import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const agreements = {
  infoAccent: (theme: Theme) => css`
    background: ${theme.accent.forest.backgroundMuted0};
    width: 100%;
    height: 100%;
    @media (max-width: ${dimensions.tabletMax}) {
      margin-top: 6rem;
      min-height: 300px;
    }
  `,
  infoModal: css`
    min-height: 600px;
    overflow-x: hidden;
  `,
  infoContent: css`
    width: 100%;
    padding: 2rem;
  `,
  infoConfirmation: css`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 1.5rem;
  `,
  successAccent: (theme: Theme) => css`
    background: ${theme.info.backgroundMuted};
    width: 100%;
    height: 100%;
    @media (max-width: ${dimensions.tabletMax}) {
      margin-top: 6rem;
      min-height: 300px;
    }
  `,
  successModal: css`
    min-height: 300px;
  `,

  successConfirmation: css`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 1.5rem;
  `,
  linkBtn: (theme: Theme) => css`
    color: ${theme.system.borderFocused};
  `,

  modalColumns: css`
    width: 100%;
  `,
};
